// extracted by mini-css-extract-plugin
module.exports = {"actionWrapper":"SelectMicrophoneModal_actionWrapper__2Od-C","iconWrapper":"SelectMicrophoneModal_iconWrapper__2RPgW","divBgIcon":"SelectMicrophoneModal_divBgIcon__3PNqX"};